export type WithdrawalStatisticsRange = 'today' | 'yesterday' | 'last_7_days' | 'last_30_days' | 'custom';

export const WITHDRAWAL_STATISTICS_RANGE_LABELS: Record<WithdrawalStatisticsRange, string> = {
  today: '今日',
  yesterday: '昨日',
  last_7_days: '最近7天',
  last_30_days: '最近30天',
  custom: '自定义',
};

export const QUICK_WITHDRAWAL_STATISTICS_RANGES: WithdrawalStatisticsRange[] = [
  'today',
  'yesterday',
  'last_7_days',
  'last_30_days',
];

export interface WithdrawalStatisticsChannelDTO {
  key: string;
  label: string;
}

export interface WithdrawalStatisticsAmountDTO {
  withdrawal_count: number;
  total_amount_fen: number;
  total_amount_yuan: string;
  success_amount_fen: number;
  success_amount_yuan: string;
  failed_amount_fen: number;
  failed_amount_yuan: string;
  pending_amount_fen: number;
  pending_amount_yuan: string;
}

export interface WithdrawalStatisticsRowDTO extends WithdrawalStatisticsAmountDTO {
  date: string;
  channel: string;
  channel_label: string;
}

export interface WithdrawalStatisticsResponseDTO {
  range: {
    start_date: string;
    end_date: string;
  };
  channels: WithdrawalStatisticsChannelDTO[];
  summary: WithdrawalStatisticsAmountDTO;
  items: WithdrawalStatisticsRowDTO[];
}
